export default __webpack_public_path__ + "static/media/people_type_female.52e5aa37.svg";